import React, { useState } from 'react';
import { supabase } from '../supabaseClient'; // Path ta check kore nish

function AdminLoginModal({ onClose, onLoginSuccess }) {
  // ID er bodole Email use korchi karon Supabase by default email auth support kore
  const [adminCreds, setAdminCreds] = useState({ email: '', pass: '' });
  const [loginError, setLoginError] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const executeLogin = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    setLoginError(false);

    // ==========================================
    // SUPABASE SECURE LOGIN
    // Frontend-e kono password save kora nei!
    // ==========================================
    const { data, error } = await supabase.auth.signInWithPassword({
      email: adminCreds.email,
      password: adminCreds.pass,
    });

    if (error) {
      setLoginError(true);
      setIsLoading(false);
    } else {
      onLoginSuccess(); 
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  };

  return (
    <div 
      className="fixed inset-0 z-[100] flex items-center justify-center p-4 bg-deep-charcoal/95 backdrop-blur-lg"
      role="dialog"
      aria-modal="true"
    >
      <div className="bg-white w-full max-w-md rounded-[2.5rem] shadow-2xl p-8 md:p-10 relative border-[6px] border-[#FDFBF7] animate-scale-up">
        <button 
          onClick={onClose} 
          className="absolute top-6 right-6 text-gray-400 hover:text-deep-charcoal w-8 h-8 flex items-center justify-center rounded-full hover:bg-gray-100 transition-all"
        >
          ✕
        </button>
        
        <div className="text-center mb-10">
          <div className="w-16 h-16 bg-gradient-to-tr from-ocean-teal/20 to-ocean-teal/5 rounded-full flex items-center justify-center mx-auto mb-4 border border-ocean-teal/10">
            <span className="text-2xl">🔐</span>
          </div>
          <h2 className="text-2xl font-serif font-bold text-deep-charcoal">Admin Workspace</h2>
          <p className="text-[10px] font-bold uppercase tracking-[0.2em] text-gray-400 mt-2">Restricted Access</p>
        </div>

        <form onSubmit={executeLogin} className="space-y-5">
          <div className="space-y-2">
            <label className="text-[10px] font-black uppercase tracking-[0.2em] text-gray-400 pl-2">Admin Email</label>
            <input 
              type="email" required 
              className="w-full px-6 py-4 rounded-xl bg-[#FDFBF7] border border-gray-100 focus:border-ocean-teal/50 focus:ring-4 focus:ring-ocean-teal/10 outline-none transition-all font-bold text-deep-charcoal" 
              placeholder="admin@domain.com"
              onChange={(e) => setAdminCreds({...adminCreds, email: e.target.value})}
            />
          </div>
          <div className="space-y-2">
            <label className="text-[10px] font-black uppercase tracking-[0.2em] text-gray-400 pl-2">Password</label>
            <input 
              type="password" required 
              className="w-full px-6 py-4 rounded-xl bg-[#FDFBF7] border border-gray-100 focus:border-ocean-teal/50 focus:ring-4 focus:ring-ocean-teal/10 outline-none transition-all font-bold text-deep-charcoal" 
              placeholder="••••••••"
              onChange={(e) => setAdminCreds({...adminCreds, pass: e.target.value})}
            />
          </div>

          {loginError && (
            <div className="bg-red-50 text-red-600 text-xs font-bold px-4 py-3 rounded-xl text-center border border-red-100 animate-pulse">
              Invalid Credentials. Please try again.
            </div>
          )}

          <button 
            type="submit" 
            disabled={isLoading}
            className="w-full bg-deep-charcoal text-white font-black uppercase tracking-[0.2em] text-sm py-4 rounded-xl shadow-lg hover:bg-ocean-teal hover:shadow-ocean-teal/30 active:scale-[0.98] transition-all mt-4 disabled:opacity-70"
          >
            {isLoading ? 'Verifying...' : 'Verify & Enter'}
          </button>
        </form>
      </div>
    </div>
  );
}

export default AdminLoginModal;